import React, { useState, useEffect } from "react";
import PropertyCard from "./PropertyCard";
import "./featuredProperties.css";
import { FaFilter, FaSortAmountDown, FaList, FaSearch } from "react-icons/fa";

// Enhanced properties data with more details
const properties = [
  {
    id: 101,
    title: "Luxury 4BHK Villa",
    location: "Bandra West, Mumbai",
    image: "https://images.unsplash.com/photo-1613977257363-707ba9348227",
    type: "For Sale",
    isFeatured: true,
    imageCount: 5,
    listedDate: "2023-11-15",
    viewCount: 1250,
    propertyType: "residential"
  },
  {
    id: 102,
    title: "Commercial Office Space",
    location: "CG Road, Ahmedabad",
    image: "https://images.unsplash.com/photo-1497366216548-37526070297c",
    type: "For Sale",
    isFeatured: true,
    imageCount: 4,
    listedDate: "2023-11-20",
    viewCount: 2100,
    propertyType: "industrial"
  },
  {
    id: 103,
    title: "Premium Studio Apartment",
    location: "Indiranagar, Bangalore",
    image: "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688",
    type: "For Rent",
    isFeatured: true,
    imageCount: 3,
    listedDate: "2023-12-05",
    viewCount: 720,
    propertyType: "domestic"
  },
  {
    id: 104,
    title: "Prime Office Space",
    location: "Connaught Place, Delhi",
    image: "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267",
    type: "For Sale",
    isFeatured: true,
    imageCount: 4,
    listedDate: "2023-11-25",
    viewCount: 1890,
    propertyType: "industrial"
  },
  {
    id: 105,
    title: "Penthouse with View",
    location: "Worli, Mumbai",
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c",
    type: "For Sale",
    isFeatured: true,
    imageCount: 8,
    listedDate: "2023-11-30",
    viewCount: 3200,
    propertyType: "residential"
  },
  {
    id: 106,
    title: "Co-working Space",
    location: "Sector 62, Noida",
    image: "https://images.unsplash.com/photo-1497366216548-37526070297c",
    type: "For Rent",
    isFeatured: true,
    imageCount: 3,
    listedDate: "2023-12-03",
    viewCount: 950,
    propertyType: "industrial"
  },
  {
    id: 107,
    title: "3BHK Apartment with Garden",
    location: "Koramangala, Bangalore",
    image: "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00",
    type: "For Sale",
    isFeatured: true,
    imageCount: 6,
    listedDate: "2023-12-10",
    viewCount: 1500,
    propertyType: "residential"
  },
  {
    id: 108,
    title: "Warehouse Space",
    location: "Bhiwandi, Mumbai",
    image: "https://images.unsplash.com/photo-1487956382158-bb926046304a",
    type: "For Rent",
    isFeatured: true,
    imageCount: 4,
    listedDate: "2023-12-08",
    viewCount: 850,
    propertyType: "industrial"
  },
  {
    id: 109,
    title: "Farmhouse with Pool",
    location: "Lonavala, Maharashtra",
    image: "https://images.unsplash.com/photo-1518780664697-55e3ad937233",
    type: "For Sale",
    isFeatured: false,
    imageCount: 7,
    listedDate: "2023-12-01",
    viewCount: 1800,
    propertyType: "domestic"
  },
  {
    id: 110,
    title: "Retail Shop Space",
    location: "South Extension, Delhi",
    image: "https://images.unsplash.com/photo-1504384308090-c894fdcc538d",
    type: "For Rent",
    isFeatured: true,
    imageCount: 3,
    listedDate: "2023-12-12",
    viewCount: 620,
    propertyType: "industrial"
  },
  {
    id: 111,
    title: "2BHK Apartment",
    location: "Hinjewadi, Pune",
    image: "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2",
    type: "For Sale",
    isFeatured: true,
    imageCount: 5,
    listedDate: "2023-12-07",
    viewCount: 1100,
    propertyType: "residential"
  },
  {
    id: 112,
    title: "Villa with Private Beach",
    location: "Goa",
    image: "https://images.unsplash.com/photo-1613977257363-707ba9348227",
    type: "For Sale",
    isFeatured: true,
    imageCount: 9,
    listedDate: "2023-12-15",
    viewCount: 4200,
    propertyType: "domestic"
  },
  {
    id: 113,
    title: "Industrial Plot",
    location: "Manesar, Gurgaon",
    image: "https://images.unsplash.com/photo-1542601906990-b4d3fb778b09",
    type: "For Sale",
    isFeatured: false,
    imageCount: 2,
    listedDate: "2023-11-28",
    viewCount: 750,
    propertyType: "land"
  },
  {
    id: 114,
    title: "Showroom Space",
    location: "MG Road, Jaipur",
    image: "https://images.unsplash.com/photo-1497366754035-f200968a6e72",
    type: "For Rent",
    isFeatured: true,
    imageCount: 4,
    listedDate: "2023-12-18",
    viewCount: 930,
    propertyType: "industrial"
  }
];

export default function FeaturedProperties() {
  const [visibleCount, setVisibleCount] = useState(6);
  const [viewMode, setViewMode] = useState("grid");
  const [filterType, setFilterType] = useState("all");
  const [propertyTypeFilter, setPropertyTypeFilter] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");
  const [sortBy, setSortBy] = useState("featured");

  // Filter properties based on selected type
  const filteredProperties = properties.filter(property => {
    // Sale/Rent filter
    if (filterType === "sale" && property.type !== "For Sale") return false;
    if (filterType === "rent" && property.type !== "For Rent") return false;

    // Property Type filter
    if (propertyTypeFilter !== "all" && property.propertyType !== propertyTypeFilter) return false;

    // Search filter
    if (searchTerm.trim() !== "") {
      const searchLower = searchTerm.toLowerCase();
      const matchesSearch =
        property.title.toLowerCase().includes(searchLower) ||
        property.location.toLowerCase().includes(searchLower) ||
        property.propertyType.toLowerCase().includes(searchLower);

      if (!matchesSearch) return false;
    }

    return true;
  });

  // Sort properties based on selected option
  const sortedProperties = [...filteredProperties].sort((a, b) => {
    switch (sortBy) {
      case "price-low":
        const priceA = parseInt(a.price ? a.price.replace(/[^0-9]/g, '') : 0);
        const priceB = parseInt(b.price ? b.price.replace(/[^0-9]/g, '') : 0);
        return priceA - priceB;

      case "price-high":
        const priceAHigh = parseInt(a.price ? a.price.replace(/[^0-9]/g, '') : 0);
        const priceBHigh = parseInt(b.price ? b.price.replace(/[^0-9]/g, '') : 0);
        return priceBHigh - priceAHigh;

      case "newest":
        return new Date(b.listedDate) - new Date(a.listedDate);

      case "featured":
      default:
        if (a.isFeatured && !b.isFeatured) return -1;
        if (!a.isFeatured && b.isFeatured) return 1;
        return new Date(b.listedDate) - new Date(a.listedDate);
    }
  });

  // Reset visible count when filters change
  useEffect(() => {
    setVisibleCount(6);
  }, [filterType, propertyTypeFilter, searchTerm, sortBy]);

  // Handle search input change
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  // Handle view more button click
  const handleViewMore = () => {
    setVisibleCount(prev => {
      const newCount = prev + 6;
      return Math.min(newCount, sortedProperties.length);
    });
  };

  // Clear all filters
  const handleResetFilters = () => {
    setFilterType('all');
    setPropertyTypeFilter('all');
    setSearchTerm('');
    setSortBy('featured');
    setVisibleCount(6);
  };

  // Check if there are more properties to show
  const hasMoreProperties = visibleCount < sortedProperties.length;

  return (
    <section className="featured-section">
      <div className="section-header">
        <div className="header-left">
          <h2 className="section-title">All Featured Properties</h2>
          <p className="section-subtitle">Discover your dream property from our curated collection</p>
        </div>

        <div className="header-right">
          <span className="properties-count">
            {sortedProperties.length} Properties Found
          </span>
        </div>
      </div>

      {/* Filters and Controls */}
      <div className="property-controls">
        <div className="filter-buttons">
          {/* Sale/Rent Filters */}
          <button
            className={`filter-btn ${filterType === 'all' ? 'active' : ''}`}
            onClick={() => setFilterType('all')}
          >
            All Properties
          </button>
          <button
            className={`filter-btn ${filterType === 'sale' ? 'active' : ''}`}
            onClick={() => setFilterType('sale')}
          >
            <FaFilter /> For Sale
          </button>
          <button
            className={`filter-btn ${filterType === 'rent' ? 'active' : ''}`}
            onClick={() => setFilterType('rent')}
          >
            <FaFilter /> For Rent
          </button>

          {/* Property Type Dropdown */}
          <div className="filter-dropdown property-type-dropdown">
            <select
              value={propertyTypeFilter}
              onChange={(e) => setPropertyTypeFilter(e.target.value)}
              className="filter-select"
            >
              <option value="all">All Property Types</option>
              <option value="residential">🏠 Residential</option>
              <option value="domestic">🏡 Domestic</option>
              <option value="industrial">🏭 Industrial</option>
              <option value="land">🌳 Land</option>
            </select>
          </div>

          {/* Search Input */}
          <div className="search-filter-container">
            <FaSearch className="search-icon" />
            <input
              type="text"
              placeholder="Search by title, location or type..."
              value={searchTerm}
              onChange={handleSearchChange}
              className="search-input"
              aria-label="Search properties by title, location or type"
            />
            {searchTerm && (
              <button
                className="clear-search-btn"
                onClick={() => setSearchTerm("")}
                aria-label="Clear search"
              >
                ✕
              </button>
            )}
          </div>
        </div>

        {/* View Controls */}
        <div className="view-controls">
          <div className="sort-dropdown">
            <FaSortAmountDown className="sort-icon" />
            <select
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              className="sort-select"
            >
              <option value="featured">Featured First</option>
              <option value="newest">Newest First</option>
              <option value="price-low">Price: Low to High</option>
              <option value="price-high">Price: High to Low</option>
            </select>
          </div>

          <div className="view-toggle">
            <button
              className={`view-btn ${viewMode === 'grid' ? 'active' : ''}`}
              onClick={() => setViewMode('grid')}
              aria-label="Grid view"
            >
              {/* Grid icon - You can add an actual grid icon here */}
              <span className="grid-icon">⎕</span>
            </button>
            <button
              className={`view-btn ${viewMode === 'list' ? 'active' : ''}`}
              onClick={() => setViewMode('list')}
              aria-label="List view"
            >
              <FaList />
            </button>
          </div>
        </div>
      </div>

      {/* Properties Grid/List */}
      <div className={`properties-container ${viewMode}`}>
        {sortedProperties.slice(0, visibleCount).map((item) => (
          <PropertyCard key={item.id} data={item} viewMode={viewMode} />
        ))}
      </div>

      {/* View More Button */}
      {hasMoreProperties && (
        <div className="view-more-section">
          <button
            className="view-more-btn"
            onClick={handleViewMore}
          >
            View More Properties ({sortedProperties.length - visibleCount} more)
          </button>
          <p className="view-more-hint">
            Showing {visibleCount} of {sortedProperties.length} properties
          </p>
        </div>
      )}

      {/* No Results Message */}
      {sortedProperties.length === 0 && (
        <div className="no-results">
          <h3>No Properties Found</h3>
          <p>Try changing your filters or check back later for new listings.</p>
          <button
            className="reset-filters-btn"
            onClick={handleResetFilters}
          >
            Reset All Filters
          </button>
        </div>
      )}

      {/* Show message when all properties are displayed */}
      {sortedProperties.length > 0 && !hasMoreProperties && visibleCount > 6 && (
        <div className="all-properties-shown">
          <p>✅ All {sortedProperties.length} properties are displayed.</p>
        </div>
      )}
    </section>
  );
}